import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { useCallHistoryContext } from 'pages/conversations/pages/calls/ui/CallHistory/context/callHistoryContext'
import { EmptyStateCallHistory } from 'pages/conversations/pages/calls/ui/CallHistory/ui/EmptyStateCallHistory/EmptyStateCallHistory'
import { CallHistoryMobileHeader } from 'pages/conversations/pages/calls/ui/CallHistory/ui/mobile/CallHistoryMobileHeader/CallHistoryMobileHeader'
import { CallHistoryMobileList } from 'pages/conversations/pages/calls/ui/CallHistory/ui/mobile/CallHistoryMobileList/CallHistoryMobileList'
import styles from './styles.module.scss'

export const CallHistoryMobileContent = observer(() => {
  const store = useCallHistoryContext()
  const {
    isEmptyState,
    isEmptySearchResults,
    isLoading,
    isLoadingStatistics,
    callHistoryTableStore,
  } = store
  const { loadingMore, setIsInfinityList } = callHistoryTableStore

  useEffect(() => {
    setIsInfinityList(true)
    return () => {
      setIsInfinityList(false)
    }
  }, [])

  if (isEmptyState) {
    return (
      <div className={styles.wrap}>
        <EmptyStateCallHistory />
      </div>
    )
  }

  const isListLoading = !loadingMore && (isLoadingStatistics || isLoading)

  return (
    <div className={styles.wrap}>
      <CallHistoryMobileHeader />
      {isListLoading && <SpinnerLoader ariaLabel={'CallHistoryMobileContent'} />}
      {!isListLoading && (isEmptySearchResults ? <NoResultsFound /> : <CallHistoryMobileList />)}
    </div>
  )
})
